/**
 * THE ARRIVAL FLOW'S LOADING STATE — the shape of the screen that is coming, not a box.
 *
 * ⚠️ A SINGLE FULL-WIDTH GREY PANEL WAS THE WRONG PROMISE. The welcome screen is a centred
 * greeting over two columns, so a block spanning the whole content area told the reader to
 * expect one thing and then replaced it with another. On a screen a passenger opens the
 * moment they land, that reads as the page changing its mind.
 *
 * ⚠️ IT MIRRORS THE REAL LAYOUT, ROW FOR ROW — the same grid, the same gaps, the same
 * block heights. The point of a skeleton is that nothing moves when the content arrives;
 * any bar here that is not where a real element goes is a jump waiting to happen.
 */
const BAR = 'animate-pulse rounded-(--radius-md) bg-(--bg-grey)'

export default function ArrivalSkeleton() {
    return (
        <div className="flex flex-col gap-6 max-md:gap-4" aria-hidden="true">
            {/* The greeting, centred and spanning both columns */}
            <div className="flex flex-col items-center">
                <div className={`h-9 w-80 max-w-full rounded-full ${BAR}`}/>
                <div className={`mt-4 h-10 w-[22rem] max-w-full ${BAR}`}/>
                <div className={`mt-3 h-4 w-[30rem] max-w-full ${BAR}`}/>
            </div>

            <div className="grid grid-cols-12 items-start gap-5 max-md:gap-3">
                <div className="col-span-12 flex flex-col gap-5 lg:col-span-7 max-md:gap-3">
                    {/* "Your next step" card: heading, two steps, rule, delay row */}
                    <div className={`h-72 w-full rounded-(--radius-xl) ${BAR}`}/>
                    {/* The two actions, at their real height so nothing shifts */}
                    <div className="flex flex-col gap-3">
                        <div className={`h-14 w-full rounded-full ${BAR}`}/>
                        <div className={`h-14 w-full rounded-full ${BAR}`}/>
                    </div>
                    <div className={`mx-auto h-4 w-80 max-w-full ${BAR}`}/>
                </div>

                <div className="col-span-12 lg:col-span-5">
                    {/* Driver card: heading, person row, rule, vehicle row */}
                    <div className={`h-60 w-full rounded-(--radius-xl) ${BAR}`}/>
                </div>
            </div>
        </div>
    )
}

export {ArrivalSkeleton}
